import { OrderStatus } from '@core/enums/shipment-status-enum';

export const OrderStatusLocale = {
  [OrderStatus.Shipped]: $localize`Shipped`,
  [OrderStatus.Processing]: $localize`In Process`,
  [OrderStatus.PartiallyShipped]: $localize`Partial Shipped`,
  [OrderStatus.OnHold]: $localize`On Hold`,
  [OrderStatus.Cancelled]: $localize`Cancelled`,
};
